import VueElementLoading from 'vue-element-loading';
import { BasicSelect, MultiSelect } from 'vue-search-select'
import Pagination from './../../../../shared/components/pagination'
import CustomExpandableTable from '../../../../shared/components/customExpandableTable'
import Loader from '../../../../shared/components/loader'
import Multiselect from 'vue-multiselect'
import { Validator } from 'vee-validate';
import CryptoJS from 'crypto-js';
import CargoBookingServices from './../../../../cargobooking/services/cargobooking.service'
import MasterService from './../../../services/masterdata.service'
import Util from '../../../../shared/util/util';
import Papa from "papaparse";
const moment = require('moment');
import XLSX from "xlsx";
export default {
  name: 'doortodoor',
  components: {
    VueElementLoading,
    Pagination,
    BasicSelect,
    Loader,
    CustomExpandableTable,
    Multiselect,
    Validator,

  },
  data: function () {
    return {
      accordianTab: {
        1: false,
        2: false,
        3: false
      },
      RateId:null,
      expanded: false,
      isBasicInfoLoading: false,
      isLoading: false,
      filename: null,
      validatedData: [{
				isupload: null,
				validdata: 0,
				invaliddata: 0,
				tableItems : [],
				totalPage : 0,
				currentPage :  1,
				totalCount : 0,
				offset :  0,
				pageLimit : 10,
				totalrecords: 0,
				file: null,
				filename: null,
        isdisabled:false
			},{
				isupload: null,
				validdata: 0,
				invaliddata: 0,
				tableItems : [],
				totalPage : 0,
				currentPage :  1,
				totalCount : 0,
				offset :  0,
				pageLimit : 10,
				totalrecords: 0,
				file: null,
				filename: null,
        isdisabled:false
			},{
				isupload: null,
				validdata: 0,
				invaliddata: 0,
				tableItems : [],
				totalPage : 0,
				currentPage :  1,
				totalCount : 0,
				offset :  0,
				pageLimit : 10,
				totalrecords: 0,
				file: null,
				filename: null,
        isdisabled:false
			},
      {
				isupload: null,
				validdata: 0,
				invaliddata: 0,
				tableItems : [],
				totalPage : 0,
				currentPage :  1,
				totalCount : 0,
				offset :  0,
				pageLimit : 10,
				totalrecords: 0,
				file: null,
				filename: null,
        isdisabled:false
			},
      {
				isupload: null,
				validdata: 0,
				invaliddata: 0,
				tableItems : [],
				totalPage : 0,
				currentPage :  1,
				totalCount : 0,
				offset :  0,
				pageLimit : 10,
				totalrecords: 0,
				file: null,
				filename: null,
        isdisabled:false
			},
      {
				isupload: null,
				validdata: 0,
				invaliddata: 0,
				tableItems : [],
				totalPage : 0,
				currentPage :  1,
				totalCount : 0,
				offset :  0,
				pageLimit : 10,
				totalrecords: 0,
				file: null,
				filename: null,
        isdisabled:false
			}],
      categoryName: null,
      categoryNameList:[],
      TemplateDescription: null,
      EffectiveDate: null,
      EffectiveTo: null,
      EffectiveFrom: null,
      EffectiveToDateSearch: null,
      airlineList: [],
      airline: null,
      flag: true,
      disabled: false,
      showprogress: null,
      showprogress: false,
      progressarr: ['stop', 'stop', 'stop', 'stop'],
      userName: "",
      validdateddatalist: [],
      categoryerr: null,
      airlineerr: null,
      effectiveDateerr: null,
      templateDescriptionerr:null,
      chk: false,
      columnkeys:null,
      templateNumber:null,
      previouAirlineData:false,
      airlinepre:null,
      TotalDataPreviousAirline:[],
      totalCountAirline:0,
      submitflagforprerecord:true,
      disableeffectivedate:false,
      disableairline:false,
      disabledescription:false,
      disablecategory:false,
      headererr:0,
      Base_Rate:"../static/portToPortTemplatefiles/Base_Rate.xlsx",
      Original_Terminal:"../static/portToPortTemplatefiles/Original_Terminal.xlsx",
      Destination_Terminal:"../static/portToPortTemplatefiles/Destination_Terminal.xlsx",
      Other_Charges:"../static/portToPortTemplatefiles/Other_Charges.xlsx",
      Origin_Operator:"../static/portToPortTemplatefiles/Origin_Operator.xlsx",
      Destination_Operator:"../static/portToPortTemplatefiles/Destination_Operator.xlsx",

      templatetype:0,
      InvalidData:null,
      FinalSubmit:1,
      AllfilesUploaded:false,
      isContentVisible: true,

    }
  },
  async mounted() {
    this.accordianTab[1] = true;
    this.getAirCargoRateOptions();
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.checkFromDate()
    this.getCategoryDataForPortToPort()
  },
  methods: {
    showRoutelist() {
      this.$confirm("Are you sure to go back?, All the unsave changes will be deleted. ", "", "question").then(() => {
        this.$emit("goBackToParent")
      }).catch((err) => {
        console.log(err)
      })
    },
    async getAirCargoRateOptions() {
      try {
        this.isLoading = true
        let inputpayload = {}
        let result = await CargoBookingServices.getAirCargoData(inputpayload)
        this.isLoading = false
        if (result.data.code == 200) {
          result.data.data.resultairlinename.forEach(el => {
            this.airlineList.push({
              'id': el.id,
              'label': el.airlinename
            })
          })
          this.isLoading = false
        }
        else {
          this.isLoading = false
          this.$alertify.error(result.data.message)
        }
      } catch (err) {
        this.isLoading = false
      }
    },
    async getCategoryDataForPortToPort() {
      try {
        this.isLoading = true;
        let inputPayload = {
          // "offset": this.offset,
          // "limit": this.pageLimit,
        }
        let result = await MasterService.GetCategoryListingAndVersionDetails(inputPayload)
        if (result.data.code == 200) {
          result.data.data.forEach(el => {
            this.categoryNameList.push({
              'id': el.id,
              'label': el.categoryname
            })
          })
        } else {
          this.isLoading = false
          this.$alertify.error(result.data.message)
        }
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
      }
    },
    async getAirlineRatesDataAgainstAirline(data) {
      try {
       if(this.categoryName==null)
       {
        this.categoryerr = "Please Select Category Name"
        return false
       }
        this.isLoading = true;
        let inputPayload = {}
        if (this.categoryName) {
          inputPayload.category = parseInt(this.categoryName.id);
        }
        if (data.id) {
          inputPayload.airline = data.id;
        }
        let result1 = await MasterService.GetAirlineRatesDetails(inputPayload)
        if (result1.data.code == 200) {
          if (result1.data.data != null) {
            this.$fire({
              title: "Record against "+ `${this.airline.label}` +" and "+ `${this.categoryName.label}` +" category is already exists",
              text: "Location Uploaded Successfully",
              type: "success",
              html: "Do you want to update the data ?",
              showCancelButton: true,
              cancelButtonColor: '#FF0000',
              confirmButtonColor: '#008000',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
              reverseButtons: false
            }).then(async (result) => {
              if (result.value == true) {
                this.EffectiveToDateSearch = result1.data.data.effectivefrom
                this.TemplateDescription = result1.data.data.description
                this.submitflagforprerecord = false
                this.disableeffectivedate=true
                this.disabledescription=true
                this.disablecategory=true
                this.disableairline=true
                this.categoryerr= null,
                this.airlineerr= null,
                this.effectiveDateerr= null,
                this.templateDescriptionerr=null,
                this.chk = true
                this.RateId = result1.data.data.id
              } else {
                try {
                  this.isLoading = true;
                  let inputPayload1 = {
                  }
                  if (result1.data.data.id) {
                    inputPayload1.id = result1.data.data.id
                  }
                  let result = await MasterService.DeleteAirrateEntry(inputPayload1)
                  if (result.data.code == 200) {
                  } else {
                    this.$alertify.error(result.data.message)
                  }
                  this.isLoading = false;
                } catch (err) {
                  this.isLoading = false;
                }
                return false;
              }
            }).catch((err) => {
              this.isLoading = false
            });
          }
          this.isLoading = false;
        }

      } catch (err) {
        this.isLoading = false;
      }
    },
    mainReset()
    {
        this.airline = null,
        this.categoryName = null
        this.TemplateDescription = null
        this.EffectiveToDateSearch = null
        this.airlineerr = " "
        this.categoryerr = " "
        this.effectiveDateerr = " "
        this.templateDescriptionerr=" "
        this.AllfilesUploaded=false
    },
    resetFilter(index) {
      this.AllfilesUploaded=false
      this.validatedData[index].filename=null
      this.validatedData[index].isupload =null
      this.validatedData[index].invaliddata=0
      this.validatedData[index].file = null;
      this.validatedData[index].filename = null;
      this.validatedData[index].isdisabled = false;
      this.$validator.reset();
      this.filename=null
      switch (index) {
        case 0:
          this.$refs.uploadFile1.value=null;
            break;
        case 1:
          this.$refs.uploadFile2.value=null;
            break;
        case 2:
          this.$refs.uploadFile3.value=null;
            break;
        case 3:
          this.$refs.uploadFile4.value=null;
            break;
        case 4:
          this.$refs.uploadFile5.value=null;
            break;
        case 5:
          this.$refs.uploadFile6.value=null;
            break;
    }

      this.validatedData[1].upload
    },
    AllUploadReset()
    {
      this.validatedData[0].filename=null
      this.validatedData[0].isupload =null
      this.validatedData[0].invaliddata=0
      this.validatedData[0].isdisabled = false;
      this.validatedData[1].filename=null
      this.validatedData[1].isupload =null
      this.validatedData[1].invaliddata=0
      this.validatedData[1].isdisabled = false;
      this.validatedData[2].filename=null
      this.validatedData[2].isupload =null
      this.validatedData[2].invaliddata=0
      this.validatedData[2].isdisabled = false;
      this.validatedData[3].filename=null
      this.validatedData[3].isupload =null
      this.validatedData[3].invaliddata=0
      this.validatedData[3].isdisabled = false;
      this.validatedData[4].filename=null
      this.validatedData[4].isupload =null
      this.validatedData[4].invaliddata=0
      this.validatedData[4].isdisabled = false;
      this.validatedData[5].filename=null
      this.validatedData[5].isupload =null
      this.validatedData[5].invaliddata=0
      this.validatedData[5].isdisabled = false;
      this.filename=null
      this.AllfilesUploaded=false
    },
    saveTemplate() {
      if (this.checkerr()) {
        return false
      };
      this.chk = true
      this.flag = false
    },
    checkerr() {
      let err = 0
      if (this.categoryName == null) {
        this.categoryerr = "Please Select Category Name"
        err = 1
      }
      else {
        this.categoryerr = " "
      }
      if (this.airline == null) {
        this.airlineerr = "Please Select Airline Name"
        err = 1
      }
      else {
        this.airlineerr = " "
      }
      if (!this.EffectiveToDateSearch) {
        this.effectiveDateerr = "Please Enter Effective Date"
        err = 1
      }
      else {
        this.effectiveDateerr = " "
      }
      if (!this.TemplateDescription) {
        this.templateDescriptionerr = "Please Enter Template Description"
        err = 1
      }
      else {
        this.templateDescriptionerr = " "
      }

      if (err == 0) {
        return false
      }
      else {
        return true
      }
    },
    saveTemplate2() {
      this.flag = true
    },
    groupBy(array, property) {
      var hash = {};
      for (var i = 0; i < array.length; i++) {
        if (!hash[array[i][property]]) hash[array[i][property]] = [];
        hash[array[i][property]].push(array[i]);
      }
      return hash;
    },
    async uploadPortToPort(e,index,templateNumber) {
      // this.validatedData[index].isupload = 0;
      this.validatedData[index].validdata = 0;
      this.validatedData[index].invaliddata = 0;
      this.validatedData[index].tableItems = [];
      this.validatedData[index].totalPage = 0;
      this.validatedData[index].currentPage =  1;
      this.validatedData[index].totalCount = 0;
      this.validatedData[index].offset =  0;
      this.validatedData[index].pageLimit = 10;
      if (!/\.(xls|xlsx)$/.test(e.target.files[0].name.toLowerCase())) {
        this.$refs.files.value = null;
        this.validatedData[index].isupload = 2;
        return this.$alert('The upload format is incorrect. Please download template for correct format', "", "error");
      } 
      this.filename = e.target.files[0].name;
      this.validatedData[index].file = e.target.files[0];
      this.validatedData[index].filename = e.target.files[0].name;
      // this.validatedData[index].isfilechose = true;
      this.validatedData[index].isvalidationdone = false;
      this.validatedData[index].isdisabled = true;
      this.validatedData[index].invaliddata=0
      this.templateNumber=templateNumber
      this.showprogress = true;
      const files = e.target.files;
      this.file = e.target.files[0]
      this.submitFile(index)
    },
    submitFile(index) {
      try {
        this.$validator.validateAll("uploadform").then((result) => {
          if (!result) {
          }else {
            this.startUpload(index);
          }
        }).catch(() => {
          this.validatedData[index].isupload = 2;
          return false;
        });
      } catch (error) {
        this.validatedData[index].isupload = 2;
      }
    },
    async startUpload(index) {
      try {
        
        this.$set(this.progressarr, 0, 'start')
        this.isEditing = true;
        this.showSpinner = true;
        this.stepOne = await this.uploadFile(this.file,index)
      } catch (error) {
        this.validatedData[index].isupload = 2;
      }
    },
    async CreateAirlineRates()
    {
      try{
        if (this.checkerr()) {
          return false
        };
        let inputPayload = {}
      if(this.categoryName){
        inputPayload.category = parseInt(this.categoryName.id);
      }
      if(this.TemplateDescription){
        inputPayload.description = this.TemplateDescription;
      }
      if(this.airline){
        inputPayload.airline = this.airline.id;
      }
      if(this.EffectiveToDateSearch){
        inputPayload.effectivefrom = this.EffectiveToDateSearch;
      }

      inputPayload.lastmodifiedby = this.userName;
      inputPayload.businesstype = 1;
      this.isLoading = true;
      let result = await MasterService.createAirlineRate(inputPayload)
      this.RateId=result.data.data
      if(result.data.code == 200){
        this.isLoading = false;
        this.chk = true
        this.flag = false
        this.$alert("Created Successfully", "", "success");
        this.submitflagforprerecord = false
        this.disableeffectivedate=true
        this.disabledescription=true
        this.disablecategory=true
        this.disableairline=true
        this.isContentVisible = false;
        
      } else{
        this.$alert(result.data.message, "", "error");
        this.isLoading = false;
      }
    }
    catch(err)
    {
      this.isLoading = false
    }
    },
    async SaveUploadedAirlineRates()
    {
      try{
        // if (this.checkerr()) {
        //   return false
        // };
        this.FinalSubmit=0
        this.AllfilesUploaded=false
        let uploadedCount=0
        for(let i=0;i<6;i++)
        {
          if (this.validatedData[i].isupload==1) {
            this.AllfilesUploaded=true
            uploadedCount=uploadedCount+1
          }
          else{
            this.AllfilesUploaded=false
          }
        }
        let inputPayload = {}
    
      inputPayload.rateid = this.RateId;
     if(uploadedCount==6)
     {
      let result = await MasterService.SaveUploadedAirlineRates(inputPayload)
      this.RateId=result.data.data
      if(result.data.code == 200){
        this.chk = true
        this.flag = false
        this.FinalSubmit=1
        this.$alert("Created Successfully", "", "success");
        this.disabled = true;
        this.$emit("goBackToParent")
        this.AllUploadReset()
      } else{
        this.FinalSubmit=1
        this.$alert(result.data.message, "", "error");
      }
     }
     else{
      this.FinalSubmit=1
      this.$alert("Please Upload All files", "", "error");
     }
    }
    catch(err)
    {
      this.FinalSubmit=1
    }
    },
    async uploadFile(file,index) {
      try {
        let formData = new FormData();
        formData.append('file', this.file);
        formData.append('lastmodifiedby', this.userName);
        formData.append('createdby', this.userName);
        formData.append('rateid',this.RateId);
        formData.append('templatetype',this.templateNumber )
        formData.append('airline',this.airline.id )
        this.validatedData[index].isupload=0
        let result = await MasterService.uploadCSVFile(formData);
        if (result.data.code == 200) {
          this.validatedData[index].isupload=1
          this.$alert(result.data.message?result.data.message:"Uploaded Successfully", "", "success");
          this.fileid = result.data.data.fileid
          this.totaldata = result.data.data.totaldata;
          return true
        } else {
          this.validatedData[index].isupload=2
          this.$set(this.progressarr, 0, 'stop')
          this.showSpinner = false;
          this.showError = true;
          this.$alert(result.data.message, "Error", "error");
          try{
            this.validatedData[index].isupload=2
            let tempdata=result.data.data
            if (tempdata.length > 0) {
              tempdata.forEach(el => {
                el.Errors= el.Errors.join(', ')
              });
            }
            this.validatedData[index].invaliddata = 1;
            this.InvalidData=tempdata
          }
          catch(err)
          {
            this.validatedData[index].isupload=2
          }
          return false
        }
      } catch (err) {
        this.$set(this.progressarr, 0, 'stop')
        this.showSpinner = false;
        this.showError = true;
        this.$alert("Internal server error. Please try again.", "", "error");
        this.validatedData[index].isupload=2
      }
    },
 numberToLetters(nNum) {
  var result;
  if (nNum <= 26) {
      result = this.letter(nNum);
  } else {
      var modulo = nNum % 26;
      var quotient = Math.floor(nNum / 26);
      if (modulo === 0) {
          result = this.letter(quotient - 1) + this.letter(26);
      } else {
          result = this.letter(quotient) + this.letter(modulo);
      }
  }

  return result;
},
toggleContent() {
  this.isContentVisible = !this.isContentVisible;
},

 letter(nNum) {
  var a = "A".charCodeAt(0);
  return String.fromCharCode(a + nNum - 1);
},
checkFromDate()
{
 var dtToday = new Date();
 var month = dtToday.getMonth() + 1;
 var day = dtToday.getDate();
 var TOday = dtToday.getDate();
 var year = dtToday.getFullYear();
if(month < 10)
    month = '0' + month.toString();
if(day < 10)
 day = '0' + day.toString();
var minDate = year + '-' + month + '-' + day;
this.EffectiveFrom=minDate
var maxDate = year + '-' + month + '-' + dtToday.getDate();

},
removeAirline()
{
  this.airline=null
},
downloadXlsInvalidRecords(file,index)
{ try{
  let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
  const data1 = XLSX.utils.json_to_sheet(this.InvalidData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, data1, 'data')
  let filen=file.substring(0, file.indexOf('.xlsx'))
  XLSX.writeFile(wb, filen+'Invalid.xlsx');
  }
  catch(err)
  {
    this.isLoading = false;
  }
},
 }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/AirWalletTemplate/porttoport/porttoport.component.js